export default "tr.disabled{text-decoration:line-through}.garage-rate{font-size:14px;white-space:nowrap;padding-right:20px}";